import React from "react";
import QRCode from "qrcode.react";
import styled from "styled-components";
const QrCode = () => {
  return (
    <Container>
      <h1>Scan to visit </h1>
      <h1 style={{ color: "#02b340", textAlign: "center" }}>
        Clean Cooking - Cookstoves distribution
      </h1>
      <h1 style={{ color: "#02b340", textAlign: "center" }}>
        (निर्धुर चूल वाटप अभियान)
      </h1>
      <QRCode
        value="http://mybucketbhugolgis1.s3-website.us-east-2.amazonaws.com/"
        style={{ width: "300px", height: "300px", marginTop: "20px" }}
      />
      <h2 style={{ color: "#02b340", textAlign: "center", marginTop: "20px" }}>
        <a href="http://mybucketbhugolgis1.s3-website.us-east-2.amazonaws.com/">
          Click here to visit the website (वेबसाइटला भेट देण्यासाठी येथे क्लिक
          करा)
        </a>
      </h2>
    </Container>
  );
};
export default QrCode;

export const Container = styled.div`
  display: flex;
  margin: 0px;
  align-items: center;
  flex-direction: column;
`;
